import nodeService from "@/services/nodejs"
import { groupBy } from "../../../helpers/formaters"

async function trafxStoreCommit(state, payload){
    await state.commit(payload.mutation, payload.value)
}

async function fetchTrafxEntriesByDate(state, form){
    state.commit("RESET_ENTRIES")
    state.commit("SET_IS_LOADING", true)

    await nodeService.getTrafxEntries(form)
        .then((response) => { state.commit('SET_ENTRIES', response.data) })
        .finally(() => { state.commit("SET_IS_LOADING", false); })
}

async function fetchTrafxFiles(state, params){
    state.commit("RESET_FILES")
    state.commit("SET_IS_LOADING", true)

    await nodeService.getTrafxFiles(params)
        .then((response) => {
            state.commit('SET_FILES', response.data) })
        .finally(() => { state.commit("SET_IS_LOADING", false); })
}

async function uploadTraxFile(state, props){
    state.commit("RESET_CURRENT_TRAFX_DATA")
    state.commit("SET_IS_LOADING", true)

    var fileContent = props.fileContent
    var atrativo = props.atrativo

    // Splitted string, turned into array
    var dataInline = fileContent.split(/\r?\n/)

    const regexDatas = /\d\d-\d\d-\d\d,\d\d:\d\d:\d\d,\d,\d,\d,\d/i;
    var DATAS = []

    const regexSerialNumber = /\*Serial Number\s+:(.*)/;
    var SERIAL_NUMBER = ""

    // const regexCounterName = /\*Counter name\s+:(.*)/;
    // var COUNTER_NAME = ""

    const regexMode = /\*Mode\s+:(.*)/;
    var MODE = ""

    const regexStoredRecords = /\**Stored records\s+:(.*)/;
    var STORED_RECORDS = []

    dataInline.map(function(value, index){
        // REGEX for datetime strings like 23-02-27,15:42:12,1,0,0,0 
        if(regexDatas.test(value)){ DATAS.push(value) }

        // REGEX for strings with Serial Number
        if(regexSerialNumber.test(value)){ SERIAL_NUMBER = value.split(":")[1] }

        // REGEX for strings with Counter Name
        // if(regexCounterName.test(value)){ COUNTER_NAME = value.split(":")[1].trimRight() }

        // REGEX for strings with MODE
        if(regexMode.test(value)){ MODE = value.split(":")[1] }
        
        // REGEX for strings with STORED RECORDS
        if(regexStoredRecords.test(value)){ STORED_RECORDS.push(value.split(":")[1]) }
    })

    const records = state.getters.getFilesRecords
    const serials = state.getters.getFilesSerialNumbers
    if(serials.includes(SERIAL_NUMBER) && records.includes(STORED_RECORDS[0])){
        state.commit("SET_IS_LOADING", false)
        return Promise.reject(new Error('Este arquivo já foi enviado anteriormente!'))
    }

    // Breaking counted dates to use them as index
    DATAS = DATAS.map(function(val, idx){ return val.split(",") })

    // Grouping info based on unique dates
    DATAS = groupBy(DATAS, e => e[0])
    DATAS = Array.from(DATAS.entries())

    var TRAFX = DATAS.map(function(value, index){
        value = value[1]
        var entry = value[1].map(function(val,idx){
            var entryRow = {}
            var datetime = `${val[0]} ${val[1]}`        // "23-02-27" + "15:42:12"
            entryRow[datetime] = val[2]                 // { "23-02-27 15:42:12" : "1" }
            return entryRow
        })

        const total = entry.length
        const entriesJson =  JSON.stringify(entry)
        return {
            serial: SERIAL_NUMBER,
            prodUuid: atrativo.uuid,
            name: atrativo.product_name,
            mode: MODE,
            records: STORED_RECORDS[0],
            date: value[0],
            total: total,
            entries: entriesJson
        }
    })

    await nodeService.saveTrafx(TRAFX)
    .then((response) => {
        state.commit("SET_CURRENT_TRAFX_DATA", TRAFX)
    })
    .finally(() => {
        state.commit("SET_IS_LOADING", false)
    })
}

export default {
    uploadTraxFile,
    fetchTrafxEntriesByDate,
    fetchTrafxFiles,
    trafxStoreCommit,
}